// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__WaA3-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__IrSsZ"};